// extracted by css-extract-rspack-plugin
export default {"aliceAppTestPageHistoryHighlighter":"aliceAppTestPageHistoryHighlighter__lsc1M"};